import { CardBody, Flex, Icon, SimpleGrid, Text } from '@chakra-ui/react'
import { faLink, faHandshake } from '@fortawesome/pro-light-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { getInsurerOfferCategoryName } from 'BrokerTsLib/src/enums'
import { Link as RouterLink } from 'react-router'

import { Recap } from '@/components/Recap'
import { RecapSummaryHeader } from '@/components/RecapSummary/RecapSummaryHeader'

import { type ActiveContractItem } from '@/hooks/useWizard'

/**
 * Karta s proklikem na ostatní aktivní (sourozenecké) pojistné smlouvy
 * v rámci stejného obchodního případu.
 * Aktuálně zobrazená smlouva (currentOfferId)
 * je ze seznamu vyřazena.
 */
export const ActiveContractTiles = ({
  insuranceParamsId,
  number,
  additionalContracts,
}: {
  insuranceParamsId: string | number
  number?: number
  additionalContracts: ActiveContractItem[]
}) => {
  if (additionalContracts.length === 0) return null

  return (
    <Recap sx={{ gap: 0 }}>
      <RecapSummaryHeader number={number}>Další aktivní smlouvy</RecapSummaryHeader>

      <CardBody sx={{ px: 8, pt: 2, pb: 8 }}>
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={5} p={5}>
          {additionalContracts.map(c => (
            <Flex
              key={c.insuranceId}
              as={RouterLink}
              to={`/leasing/case/${insuranceParamsId}/steps/complete/${c.insurerOfferId}`}
              align="center"
              bg='white'
              borderWidth={1}
              borderColor="gray.200"
              borderRadius="xl"
              transition="all 0.15s ease"
              p={4}
              _hover={{
                bg: "primary.50",
                borderColor: 'primary.500',
                boxShadow: 'md',
                transform: 'translateY(-2px)',
              }}
            >
              <Flex justifyContent='center' pr={4}>
                <Icon as={FontAwesomeIcon} icon={faHandshake} fontSize="6xl" />
              </Flex>

              <Flex gap={2}>
                <Text fontWeight="bold" color="gray.800" fontSize="medium" noOfLines={1}>
                  {getInsurerOfferCategoryName(c.category) || 'Pojištění'}
                </Text>

                <Text>
                  ({c.contractNumber})
                </Text>
              </Flex>


              <Icon
                as={FontAwesomeIcon}
                icon={faLink}
                // color="gray.400"
                fontSize="2xl"
                flexShrink={0}
                ml='auto'
              />
            </Flex>
          ))}
        </SimpleGrid>
      </CardBody>
    </Recap>
  )
}
